import axios from "axios";
import { makeAutoObservable, toJS } from "mobx";
import loginStore from "./loginStore";
import { toast } from "react-toastify";

class VoiceStore {
  step1Values = {};
  step2Values = {};
  step = 1;
  stepperVisible = false;
  initialSearchResults = [];
  searchKeyword = null;
  searchQuery = null;
  showPinnedTalent = false;
  talents = [];
  talent = null;
  dropdownData = {
    languageOptions: [],
    accentOptions: [],
    genderOptions: [],
    ageGroupOptions: [],
    styleOptions: [],
  };

  searchResults = [];
  currentVoice = null;
  isPlaying = false;
  waveSurfer = null;
  loadResult = false;

  talentDetailsModalVisible = false;
  updateTalentDetailsModalVisible = false;
  updateTalentVoicesModalVisible = false;

  searchPayload = {
    gender: [],
    languages: [],
    accents: [],
    age: [],
    style: [],
    additionalTags: [],
  };

  searchNavVisible = false;

  videoModal = null;

  progress = 0;

  constructor() {
    makeAutoObservable(this);
  }
  setInitialSearchResult = (data) =>{
     this.initialSearchResults = data;
  }
  setSearchResults = (data) =>{
     this.searchResults = data;
  }
  setLoadResult = (value) =>{
     this.loadResult = value;
  }
  setTalent = (talent) => {
    this.talent = talent;
  };
  setEmptySearchResult = ()=>{
    this.searchResults = [];
  };
  setSearcKeyword =(value)=>{
    this.searchKeyword = value;
  };
  setSearchQuary =(value)=>{
    this.searchQuery = value;
  };
  setShowPinnedTalent =(value)=>{
    this.showPinnedTalent = value;
  };
  setUpdateTalentVoicesModalVisible(visible) {
    this.updateTalentVoicesModalVisible = visible;
  }

  setUpdateTalentDetailsModalVisible(visible) {
    this.updateTalentDetailsModalVisible = visible;
  }

  setVideoModal(data) {
    this.videoModal = data;
  }

  togglePlayPause(bool) {
    if (bool) {
      this.isPlaying = bool;
    } else {
      this.isPlaying = !this.isPlaying;
    }
  }

  nextStep() {
    this.step += 1;
  }

  prevStep() {
    this.step -= 1;
  }

  changeStepperVisible(visible) {
    if (visible) {
      this.stepperVisible = true;
    } else {
      this.stepperVisible = false;
      this.step1Values = {};
      this.step2Values = {};
      this.step = 1;
    }
  }

  setStep1Values(data) {
    this.step1Values = data;
  }

  setStep2Values(data) {
    this.step2Values = data;
  }

  async createTalent() {
    const formData = new FormData();

    if (this.step2Values.files.length > 0) {
      this.step2Values.files.forEach((file, index) => {
        formData.append(
          `VoiceFiles[${index}].Gender`,
          file.tags.gender && file.tags.gender.value
            ? file.tags.gender.value
            : ""
        );
        formData.append(`VoiceFiles[${index}].FileName`, file.fileName);
        formData.append(
          `VoiceFiles[${index}].Accents`,
          file.tags.accents?.map((accent) => accent.value).join(",")
        );
        formData.append(`VoiceFiles[${index}].VoiceFile`, file.voiceFile);
        formData.append(`VoiceFiles[${index}].FileExtension`, file.fileType);
        formData.append(
          `VoiceFiles[${index}].AdditionalTags`,
          file.tags.additionalTags
            ?.map((additionalTag) => additionalTag.value)
            .join(",")
        );
        formData.append(
          `VoiceFiles[${index}].Styles`,
          file.tags.styles?.map((style) => style.value).join(",")
        );
        formData.append(
          `VoiceFiles[${index}].Languages`,
          file.tags.languages?.map((language) => language.value).join(",")
        );
        formData.append(
          `VoiceFiles[${index}].AgeGroup`,
          file.tags.ageGroups?.map((ageGroup) => ageGroup.value).join(",")
        );
      });
    }

    formData.append("TalentName", this.step1Values.talentName);
    formData.append("MobileNo", this.step1Values.mobileNo);
    formData.append("Email", this.step1Values.email);
    formData.append("Dob", this.step1Values.dob);
    formData.append(
      "SocialAccounts",
      JSON.stringify(this.step1Values.socialAccounts)
    );
    formData.append("Nationality", this.step1Values.nationality);
    formData.append(
      "Accents",
      this.step1Values.accent
        ? this.step1Values.accents?.map((accent) => accent.value).join(",")
        : ""
    );
    formData.append("Notes", this.step1Values.notes);
    formData.append("Rating", this.step1Values.rating);
    formData.append("Fee", this.step1Values.fee);

    if (this.step1Values.image) {
      formData.append("ProfileImage", this.step1Values.image);
    }

    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(
          `/api/Voice/CreateProfile`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.status) {
          toast.success(response.data.message);
          this.talents.push(response.data.data);
          resolve(response.data);
        } else {
          toast.error(response.data.message);
          reject(response.data.message);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        reject(error);
      }
    });
  }

  async getTalents() {
    await axios
      .post(
        `/api/Voice/GetProfile`,
        {
          empId: loginStore.userData.empId,
          loggedInUser: loginStore.userData.loggedInUser,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(async (response) => {
        if (response.data) {
          if (response.data.userList) {
            const sortedUserList = response.data.userList.sort((a, b) => {
              return b.IsFavorite - a.IsFavorite;
            });
            this.talents = sortedUserList;
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async deleteTalent(talentId) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios
          .delete(
            `/api/Voice/DeleteProfile`,
            {
              params: {
                talentId,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then(async (response) => {
            if (response.status === 200) {
              let newArray = this.talents.filter(
                (talent, index) => talent.TalentId !== talentId
              );
              this.talents = newArray;
              resolve(this.talents);
              toast.success(response.data.message);
            }
          })
          .catch((error) => {
            reject(error);
          });
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }

  async getTalentById(talentId) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post(
          `/api/Voice/GetProfileById`,
          {
            loggedInUser: loginStore.userData.loggedInUser,
            talentId,
            empId: loginStore.userData.empId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.status === 200) {
          this.talent = response.data.data;
          resolve(response.data.data);
          this.setTalentDetailsModalVisible(true);
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error("Error get user:", error);
        reject(error);
      }
    });
  }

  async deleteSample(sampleId) {
    return new Promise((resolve, reject) => {
      return axios
        .delete(`/api/Voice/DeleteVoice`, {
          params: {
            SampleId: sampleId,
            TalentId: this.talent.TalentId,
          },
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(async (response) => {
          if (response.status === 200) {
            toast.success(response.data.message);
            this.talent.voice_data = this.talent.voice_data.filter(
              (item) => item.sample_id !== sampleId
            );
            resolve(this.talent);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async searchVoice(payload = this.searchPayload, isFavorite=false) {
    try {
      return new Promise((resolve, reject) => {
        this.setSearchPayload(payload);
       
        this.setLoadResult(!isFavorite);
        axios
          .post(`/api/Voice/SearchVoice`, payload, {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              empId: loginStore.userData.empId,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.searchResults = response.data.data
                ? toJS(response.data.data)
                : [];
              setTimeout(() => {
                  this.setLoadResult(false);
                  // your delayed code here
                }, 200);
              this.searchResults.map((talent) => {
                talent.selected = isFavorite ? false : true;
                talent.voice_data.map((voice) => {
                  voice.voice_path = `${process.env.REACT_APP_BASE_URL}/${voice.voice_path}`;
                  voice.voice_modulation_path = `${process.env.REACT_APP_BASE_URL}/${voice.voice_modulation_path}`;
                  return voice;
                });
                return talent;
              });
              if(this.searchResults.length > 0)
              {
                  let firstTalent = voiceStore.searchResults[0];
                  let fVoice = firstTalent.voice_data[0];
                  setTimeout(() => {
                    this.setCurrentVoice({
                    talent_id: firstTalent.talent_id,
                    talent_name: firstTalent.talent_name,
                    voice_path: fVoice.voice_path,
                    voice_modulation_path:
                      fVoice.voice_modulation_path,
                    sample_id: fVoice.sample_id,
                    IsFavorite: fVoice.isFavorite,
                    profile_image_path: firstTalent.profile_image_path,
                 })}, 500);
              }
              resolve(true);
            } else {
              resolve(false);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }
 searchVoiceIndex(filter = this.searchPayload) {
  const noFiltersApplied =
    !filter.accents?.length &&
    !filter.languages?.length &&
    !filter.gender?.length &&
    !filter.style?.length &&
    !filter.age?.length &&
    !filter.additionalTags?.length;

  if (noFiltersApplied && !this.searchKeyword) {
    this.setLoadResult(true);
    setTimeout(() => {
                  this.setLoadResult(false);
                  // your delayed code here
                }, 200);
    toast.warning("There is no filters and search keyword");
    return;
  }
  const filters = [];

  if (filter.accents?.length > 0) {
    const accents = filter.accents.join(",");
    filters.push(`accent:=[${accents}]`);
  }

  if (filter.languages?.length > 0) {
    const languages = filter.languages.join(",");
    filters.push(`language:=[${languages}]`);
  }

  if (filter.gender?.length > 0) {
    const genders = filter.gender.join(",");
    filters.push(`gender:=[${genders}]`);
  }

  if (filter.style?.length > 0) {
    const styles = filter.style.join(",");
    filters.push(`style:=[${styles}]`);
  }
  

  if (filter.age?.length > 0) {
    const ages = filter.age.join(",");
    
    filters.push(`age:=[${ages}]`);
  }

  if (filter.additionalTags?.length > 0) {
    const tags = filter.additionalTags.join(",");
    filters.push(`additional_tags:=[${tags}]`);
  }
  const query = this.searchKeyword ?? "*";
  const filterBy = filters.join(" AND ");
    axios.get(`/api/Search?q=${query}&filterBy=${filterBy}`)
          .then(async(response) => {
            if(response)
            {
                
                 if(!response.data.item1 || response.data.item1.length === 0)
                        {
                          this.setEmptySearchResult();
                          this.setShowPinnedTalent(false);
                          return;
                        }
                        const sampleIds = response.data.item1.map(s => s.sample_id);
                        const uniqueSampleIds = [...new Set(sampleIds)].slice(0, 250);
                        const payload = {
                            sampleId : uniqueSampleIds
                        };
                        await this.searchVoice(payload);
                        this.setSearchPayload(filter);
                        this.setSearchQuary(this.searchKeyword);
                        if(response.data.item2)
                        {
                            this.setSearchNavVisible(true);
                            this.setShowPinnedTalent(false);
                        }
            }

          })
          .catch((error) => {
            console.error("There was an error!", error);
          });
}




  async getDropdownData() {
    try {
      axios
        .get("/api/Voice/GetDropdownData")
        .then(async (response) => {
          if (response.data) {
            this.dropdownData = await this.formattedDropdowns(
              response.data.data
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  }

  async formattedDropdowns(data) {
    return {
      languageOptions: data.language_dropdown.map((lang) => ({
        value: lang,
        label: lang,
      })),
      accentOptions: data.accent_dropdown.map((accent) => ({
        value: accent,
        label: accent,
      })),
      genderOptions: data.gender_dropdown.map((gender) => ({
        value: gender,
        label: gender,
      })),
      ageGroupOptions: data.age_dropdown.map((age) => ({
        value: age,
        label: age,
      })),
      styleOptions: data.style_dropdown.map((style) => ({
        value: style,
        label: style,
      })),
    };
  }

  get normalDropdownData() {
    return toJS(this.dropdownData);
  }

  setCurrentVoice(voice) {
    this.currentVoice = voice;
    localStorage.setItem('currentVoice', JSON.stringify(this.currentVoice));
  }

  setTalentDetailsModalVisible(visible) {
    this.talentDetailsModalVisible = visible;
  }

  updatePayload(newPayload) {
    this.searchPayload = { ...this.searchPayload, ...newPayload };
  }

  setSearchPayload(payload) {
    this.searchPayload = {
      gender: [],
      languages: [],
      accents: [],
      age: [],
      style: [],
      favorite : false,
      additionalTags: [],
    };

    const updatedSearchPayload = { ...this.searchPayload };

    Object.keys(payload).forEach((key) => {
      if (payload[key] && payload[key].length > 0) {
        updatedSearchPayload[key] = payload[key];
      }
    });

    this.searchPayload = updatedSearchPayload;
  }

  setSearchNavVisible(visible) {
    this.searchNavVisible = visible;
  }

  async setFavoriteTalent(talentId) {
    const talent = this.talents.find((talent) => talent.TalentId === talentId);
    await axios
      .post(`/api/Common/FavoriteTalent`, null, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          empId: loginStore.userData.empId,
          talentId: talentId,
          operation: talent.IsFavorite === "0" ? "insert" : "delete",
        },
      })
      .then(async (response) => {
        if (response.status === 200) {
          toast.success(response.data.message);
          if (talent.IsFavorite === "0") {
            talent.IsFavorite = "1";
          } else {
            talent.IsFavorite = "0";
          }
          const sortedUserList = this.talents.sort((a, b) => {
            return b.IsFavorite - a.IsFavorite;
          });
          this.talents = sortedUserList;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async updateTalentDetails(data) {
    try {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("ProfileImgPath", data.ProfileImgPath);
        if (data.voice_data) {
          delete data.voice_data;
        }

        if (typeof data.Accents != "string") {
          data.Accents = data.Accents?.map((accent) => accent.value).join(",");
        }

        axios
          .post(`/api/Voice/UpdateProfile`, formData, {
            params: data,
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            if (response.data.status === true) {
              this.getTalentById(this.talent.TalentId).then(() => {
                resolve(this.talent);
              });
              this.getTalents();
              toast.success(response.data.message);
            } else {
              toast.error(response?.data?.message);
              resolve(false);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    } catch (error) {
      console.error(error);
    }
  }

  updateTalentVoices(file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      formData.append("Gender", file.tags.gender?.value || "");
      formData.append("FileName", file.fileName || "");
      formData.append(
        "Accents",
        file.tags.accents?.map((accent) => accent.value).join(",") || ""
      );
      formData.append("VoiceFile", file.voiceFile);
      formData.append("FileExtension", file.fileType || "");
      formData.append(
        "AdditionalTags",
        file.tags.additionalTags?.map((tag) => tag.value).join(",") || ""
      );
      formData.append(
        "Styles",
        file.tags.styles?.map((style) => style.value).join(",") || ""
      );
      formData.append(
        "Languages",
        file.tags.languages?.map((language) => language.value).join(",") || ""
      );
      formData.append(
        "AgeGroup",
        file.tags.ageGroups?.map((ageGroup) => ageGroup.value).join(",") || ""
      );

      this.progress = 0;

      try {
        axios
          .post("/api/Voice/UpdateVoice", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            params: {
              talentId: this.talent.TalentId,
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                this.progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
              }
            },
          })
          .then((response) => {
            this.progress = 0;
            if (response.data.status) {
              toast.success(response.data.message);
              this.setUpdateTalentVoicesModalVisible(false);
              resolve(response.data.data);
            } else {
              reject(response.data.message);
              toast.error(response.data.message);
              throw new Error(response.data.message);
            }
          });
      } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
      }
    });
  }

  updateTalentVoiceTags(file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      formData.append("SampleId", file.sample_id || "");
      formData.append("TalentId", file.talent_id || "");
      formData.append(
        "AgeGroup",
        file.tags.ageGroups?.map((ageGroup) => ageGroup.value).join(",") || ""
      );
      formData.append(
        "AdditionalTags",
        file.tags.additionalTags?.map((tag) => tag.value).join(",") || ""
      );
      formData.append("Gender", file.tags.gender?.value || "");
      formData.append(
        "Styles",
        file.tags.styles?.map((style) => style.value).join(",") || ""
      );
      formData.append(
        "Accents",
        file.tags.accents?.map((accent) => accent.value).join(",") || ""
      );
      formData.append(
        "Languages",
        file.tags.languages?.map((language) => language.value).join(",") || ""
      );
      formData.append("VoiceFile", file.voiceFile || "");
      formData.append("FileExtension", file.fileType || "");

      const body = {
        sampleId: file.sample_id || "",
        talentId: this.talent.TalentId || "",
        ageGroup:
          file.tags.ageGroups?.map((ageGroup) => ageGroup.value).join(",") ||
          " ",
        additionalTags:
          file.tags.additionalTags?.map((tag) => tag.value).join(",") || " ",
        gender: file.tags.gender?.value || "",
        styles: file.tags.styles?.map((style) => style.value).join(",") || " ",
        accents:
          file.tags.accents?.map((accent) => accent.value).join(",") || " ",
        languages:
          file.tags.languages?.map((language) => language.value).join(",") ||
          " ",
      };

      try {
        axios
          .post("/api/Voice/UpdateVoiceTag", body, {
            headers: {
              "Content-Type": "application/json",
            },
            params: {
              talentId: this.talent.TalentId,
            },
          })
          .then((response) => {
            if (response.data.status) {
              toast.success(response.data.message);
              resolve(response.data.status);
            } else {
              reject(response.data.message);
              toast.error(response.data.message);
              throw new Error(response.data.message);
            }
          })
          .finally(() => {});
      } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
      }
    });
  }

  async setFavoriteMusic(
    sampleId = this.currentVoice.sample_id,
    IsFavorite = this.currentVoice.IsFavorite
  ) {
    return new Promise(async (resolve, reject) => {
      await axios
        .post(`/api/Common/FavoriteMusic`, null, {
          headers: {
            "Content-Type": "application/json",
          },
          params: {
            empId: loginStore.userData.empId,
            sampleId: sampleId,
            operation: IsFavorite === "0" ? "insert" : "delete",
          },
        })
        .then(async (response) => {
          if (response.status) {
            toast.success(response.data.message);
            if (IsFavorite === "0") {
              resolve("1");
              this.currentVoice.IsFavorite = "1";
            } else {
              resolve("0");
              this.currentVoice.IsFavorite = "0";
            }
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

const voiceStore = new VoiceStore();
export default voiceStore;
